import {FormDefinitionFormSummaryModel} from './formDefinitionFormSummary.model';
import {IWithSummaryModel} from '../../../../../common/permission/api/entity/iWithSummary.model';
import {FormDefinitionGroupModel} from '../../../group/api/entity/formDefinitionGroup.model';
import {FormDefinitionFormFieldModel} from './formDefinitionFormField.model';

export class FormDefinitionFormModel implements IWithSummaryModel<FormDefinitionFormSummaryModel> {
    summary: FormDefinitionFormSummaryModel;
    groups: FormDefinitionGroupModel[] = [];
    fields: FormDefinitionFormFieldModel[] = [];
    versionNumber: number;
    reportTemplate: string;
    aiDescription: string;
}
